<script>
import {
  ActionBar,
  ActionBarTitle,
  //ActionBarButton
} from '@/components/ui/action-bar'
import { PageContainer } from '@/components/page/page-container'
import { AppContainer } from '@/components/ui/container'
import { CashTransferService } from '@/services'

const Receive = () => import('./Receive.vue')
const Transfer = () => import('./Transfer.vue')

export default {
  data() {
    const { query } = this.$route

    return {
      receive: {
        items: [],
        pagination: {
          page: Number(query.receive_page) || 1,
          total: 0,
          pageSize: 10
        },
        isLoading: false
      },
      transfer: {
        items: [],
        pagination: {
          page: Number(query.transfer_page) || 1,
          total: 0,
          pageSize: 10
        },
        isLoading: false
      }
    }
  },

  created() {
    this.fetchReceive()
    this.fetchTransfer()
  },

  methods: {
    toHistoryPage() {
      this.$router.push({ name: 'CashTransferHistory' })
    },

    toCreatePage() {
      this.$router.push({ name: 'CashTransferCreate' })
    },

    async fetchReceive() {
      this.receive.isLoading = true

      const { page } = this.receive.pagination

      try {
        const {
          data: { result }
        } = await CashTransferService.getAll({
          status: ['requested', 'pending'],
          is_inbound: true,
          page
        })

        this.receive.items = result.results.map(item => ({
          id: item.id,
          date: new Date(item.datetime),
          origin: item.branch ? item.branch.name : '',
          method: item.to_branch_payment_method
            ? item.to_branch_payment_method.id === 1
              ? 'เงินสด'
              : this.getMethodName(
                  item.to_branch_payment_method.bank
                    ? item.to_branch_payment_method.bank.name
                    : '',
                  item.to_branch_payment_method.bank_account_id || ''
                )
            : '',
          amount: +item.amount,
          status: item.status
        }))

        this.receive.pagination.total = result.count
      } catch (e) {
        this.$notify.error(e.message)
      } finally {
        this.receive.isLoading = false
      }
    },

    async fetchTransfer() {
      this.transfer.isLoading = true

      const { page } = this.transfer.pagination

      try {
        const {
          data: { result }
        } = await CashTransferService.getAll({
          status: 'requested',
          is_inbound: false,
          page
        })

        this.transfer.items = result.results.map(item => ({
          id: item.id,
          date: new Date(item.datetime),
          destination: item.to_branch ? item.to_branch.name : '',
          method: item.branch_payment_method
            ? item.branch_payment_method.id === 1
              ? 'เงินสด'
              : this.getMethodName(
                  item.branch_payment_method.bank
                    ? item.branch_payment_method.bank.name
                    : '',
                  item.branch_payment_method.bank_account_id || ''
                )
            : '',
          amount: +item.amount,
          status: item.status
        }))

        this.transfer.pagination.total = result.count
      } catch (e) {
        this.$notify.error(e.message)
      } finally {
        this.transfer.isLoading = false
      }
    },

    getMethodName(name, id) {
      const shortId = (() => {
        const matches = id.match(/.{4}$/g)

        if (!matches) return ''

        return matches[0]
      })()

      const output = `${name} ${shortId ? '*' : ''}${shortId}`.trim()

      return output
    },

    handleReceivePageChange(page) {
      this.receive.pagination.page = page

      const { query } = this.$route

      this.$router.replace({ query: { ...query, receive_page: page } })

      this.fetchReceive()
    },

    handleTransferPageChange(page) {
      this.transfer.pagination.page = page

      const { query } = this.$route

      this.$router.replace({ query: { ...query, transfer_page: page } })

      this.fetchTransfer()
    }
  },

  render() {
    return (
      <div>
        <ActionBar>

            <el-button slot="action"
            type="primary"
            onClick={this.toCreatePage}
          >
            โอนเงิน
            </el-button>

          <ActionBarTitle>การโอนเงิน</ActionBarTitle>
        </ActionBar>
        <PageContainer>
          <AppContainer>
            <Receive
              items={this.receive.items}
              pagination={this.receive.pagination}
              loading={this.receive.isLoading}
              onPageChange={this.handleReceivePageChange}
            />
            <Transfer
              items={this.transfer.items}
              pagination={this.transfer.pagination}
              loading={this.transfer.isLoading}
              style={{ marginTop: '1.5rem' }}
              onPageChange={this.handleTransferPageChange}
            />
            <div style={{ marginTop: '1.5rem' }}>
              <el-button
                style={{ display: 'block', margin: '0 auto' }}
                onClick={this.toHistoryPage}
              >
                ประวัติการโอนย้ายเงิน
              </el-button>
            </div>
          </AppContainer>
        </PageContainer>
      </div>
    )
  }
}
</script>
